function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "birthday",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 0.000000)"
}, React.createElement("path", {
  d: "M29.9999677,14.0894505 C29.9810749,17.4031837 23.2533374,20.0501043 14.9669413,19.9992802 C6.68432379,19.950489 -0.018852993,17.2242827 3.98389712e-05,13.9105495 C0.0151541045,10.5968163 6.74478085,7.9498957 15.0311769,8.00071983 C23.3156838,8.049511 30.0169713,10.7757173 29.9999677,14.0894505 Z",
  id: "Stroke-1",
  stroke: "#B8C1C3"
}), React.createElement("path", {
  d: "M30,15 L29.9943332,25.6865466 C29.9754439,28.6645234 23.2489701,31.0432509 14.9660192,30.9994034 C6.68306836,30.9537289 -0.0188494521,28.5037492 3.98314835e-05,25.5275994 L0,15",
  id: "Stroke-3",
  stroke: "#B8C1C3",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M23,2 L23,14",
  id: "Line",
  stroke: "#B8C1C4"
}), React.createElement("path", {
  d: "M15,8.8817842e-16 L15,12",
  id: "Line-Copy-2",
  stroke: "#B8C1C4"
}), React.createElement("path", {
  d: "M7,2 L7,14",
  id: "Line-Copy",
  stroke: "#B8C1C4"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/birthday_cake.7944fb76.svg";
export { SvgComponent as ReactComponent };